export default __webpack_public_path__ + "static/craig-headshot-8ef7ac223a970d7fc3d2669bacf52f31.png";